import FBAPI from '../FBAPI';
import MarketPerformanceDetails from '../objects/MarketPerformanceDetails';

const markets = {
    getHomepagePerformance: () => {
        return FBAPI.homeMarketPerformance()
            .then((response) => {
                const { data } = response.payload;
                return new MarketPerformanceDetails(data);
            })
            .catch((error) => error.userMessage);
    },
};

export default markets;
